import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img
              src="https://static.readdy.ai/image/ec7d44241e5d5731ab0de78142a46920/6c0747ed3ed7d95f4444c2a7207439a8.jpeg"
              alt="The Auto Salon"
              className="h-10 sm:h-12 w-auto"
            />
          </div>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('services')}
              className={`text-sm font-medium transition-colors whitespace-nowrap hover:text-[#00D9FF] ${
                scrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('audio-services')}
              className={`text-sm font-medium transition-colors whitespace-nowrap hover:text-[#00D9FF] ${
                scrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              Audio
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`text-sm font-medium transition-colors whitespace-nowrap hover:text-[#00D9FF] ${
                scrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('gallery')}
              className={`text-sm font-medium transition-colors whitespace-nowrap hover:text-[#00D9FF] ${
                scrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              Gallery
            </button>
            <button
              onClick={() => scrollToSection('testimonials')}
              className={`text-sm font-medium transition-colors whitespace-nowrap hover:text-[#00D9FF] ${
                scrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              Testimonials
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`text-sm font-medium transition-colors whitespace-nowrap hover:text-[#00D9FF] ${
                scrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              Contact
            </button>
            <a
              href="tel:+13163007524"
              className={`flex items-center space-x-2 text-sm font-medium transition-colors whitespace-nowrap hover:text-[#00D9FF] ${
                scrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              <i className="ri-phone-line"></i>
              <span>(316) 300-7524</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
              scrolled ? 'text-gray-900' : 'text-white'
            }`}
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className={`lg:hidden mt-4 pb-4 space-y-3 ${scrolled ? 'bg-white' : 'bg-black/90'}`}>
            <button
              onClick={() => scrollToSection('services')}
              className={`block w-full text-left px-4 py-2 text-sm font-medium transition-colors hover:text-[#00D9FF] ${
                scrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('audio-services')}
              className={`block w-full text-left px-4 py-2 text-sm font-medium transition-colors hover:text-[#00D9FF] ${
                scrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              Audio
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`block w-full text-left px-4 py-2 text-sm font-medium transition-colors hover:text-[#00D9FF] ${
                scrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('gallery')}
              className={`block w-full text-left px-4 py-2 text-sm font-medium transition-colors hover:text-[#00D9FF] ${
                scrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              Gallery
            </button>
            <button
              onClick={() => scrollToSection('testimonials')}
              className={`block w-full text-left px-4 py-2 text-sm font-medium transition-colors hover:text-[#00D9FF] ${
                scrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              Testimonials
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`block w-full text-left px-4 py-2 text-sm font-medium transition-colors hover:text-[#00D9FF] ${
                scrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              Contact
            </button>
            <a
              href="tel:+13163007524"
              className={`flex items-center space-x-2 px-4 py-2 text-sm font-medium transition-colors hover:text-[#00D9FF] ${
                scrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              <i className="ri-phone-line"></i>
              <span>(316) 300-7524</span>
            </a>
          </div>
        )}
      </div>
    </nav>
  );
}
